import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
	iconResultFound: {
		fontSize: 65,
		color: "#bdbdbd",
	},
	messageResultFound: {
		color: "#bdbdbd",
		whiteSpace: "pre-line",
	},
});
